import { Color, EmitterType, vec, Vector } from 'excalibur';

export const boulderExplosionParticle = ({ pos = vec(0, 0), color = Color.White }) => ({
  x: pos.x,
  y: pos.y,
  width: 20,
  height: 20,
  emitterType: EmitterType.Circle,
  isEmitting: true,
  radius: 50,
  emitRate: 20,
  focusAccel: 0,
  particle: {
    minSpeed: 100,
    maxSpeed: 400,
    minAngle: 0,
    maxAngle: 0,
    opacity: 1,
    fade: false,
    life: 200,
    minSize: 3,
    maxSize: 3 * 2,
    startSize: 3 * 2,
    endSize: 3,
    acc: new Vector(0, 1500),
    // beginColor: Color.Blue,
    // endColor: Color.White,
    beginColor: color,
    endColor: color,
  },
});
